import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PlanSelection from "../Pages/PlanSelection";
import IntermediarySelection from "../Pages/IntermediarySelection/index.js";
import LifeTimePage from "../Pages/Quotes/LifeTimePage";
import PrimeSeniorPage from "../Pages/Quotes/PrimeSeniorPage";
import ProHealthPage from "../Pages/Quotes/ProHealthPage";
import SuperTopUpPage from "../Pages/Quotes/SuperTopUpPage";
import ProHealthPrimePage from "../Pages/Quotes/ProHealthPrime";
import CriticalIllnessPage from "../Pages/Quotes/CriticalIllnessPage";
import PersonalAccidentPage from "../Pages/Quotes/PersonalAccidentPage";
import AccidentShieldPage from "../Pages/Quotes/AccidentShield.jsx";
import CorporateBusiness from "../Pages/CorporateBusiness/index.js";
import SarvahPage from "../Pages/Quotes/SarvahPage.jsx";
import PartnerOnboarding from "../Pages/PartnerOnboarding/index.js";
import GroupRetail from "../Pages/GroupRetail/index.js";
import InfinixPage from "../Pages/Quotes/InfinixPage.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/">
        <Route path="/intermediary-selection" element={<IntermediarySelection />} />
        <Route path="/plan-selection" element={<PlanSelection />} />
        <Route path="lifetime-health" element={<LifeTimePage />} />
        <Route path="prohealth-prime" element={<ProHealthPrimePage />} />
        <Route path="prime-senior" element={<PrimeSeniorPage />} />
        <Route path="prohealth-insurance" element={<ProHealthPage />} />
        <Route path="super-top-up" element={<SuperTopUpPage />} />
        <Route path="/critical-illness">
          <Route index element={<CriticalIllnessPage />} />
        </Route>
        <Route path="/personal-accident">
          <Route index element={<PersonalAccidentPage />} />
        </Route>
        <Route path="/accident-shield">
          <Route index element={<AccidentShieldPage />} />
        </Route>
        <Route path="/corporate-business" element={<CorporateBusiness />} />
        <Route path="/sarvah">
          <Route index element={<SarvahPage />} />
        </Route>
        <Route path="/infinix">
          <Route index element={<InfinixPage />} />
        </Route>
        <Route path="/partner-onboarding" element={<PartnerOnboarding />} />
        <Route path="/group-retail" element={<GroupRetail />} />
      </Route>
      {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
    </Routes>
  );
};

export default AppRoutes;
